<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
      :btnToLink="'/staff/add'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div
      class="w100"
      v-if="
        typeof staff_list === 'object' && Object.keys(staff_list).length > 0
      "
    >
      <!-- {{ staff_type }} -->
      <table class="table">
        <thead>
          <tr>
            <th class="w-50">スタッフ</th>
            <th class="w-25">種別</th>
            <th colspan="2" style="width: 15%">action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in staff_list" :key="list.id">
            <td>{{ list.label }}</td>
            <td>{{ get_type_label(list.type) }}</td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
            <td>
              <bs-button
                :btnClass="'btn-danger btn-sm'"
                @to_click_event="delData(list.id)"
                >削除</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsButton from '../../atoms/BsButton.vue'
import axios from 'axios'
import config from '../../../const'

export default {
  name: 'StaffListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: 'スタッフ一覧',
      fromParentBtn: 'スタッフ登録',
      staff_obj: []
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert
  },
  computed: {
    ...mapState({
      staff_type: state => state.apidata.staff_type
    }),
    staff_list: function () {
      const lists = [...this.staff_obj]
      return lists.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    },
    get_type_label: function () {
      const staff_type = this.staff_type
      return function (key) {
        if (
          staff_type.find(type => {
            return type.key == key
          })
        ) {
          return staff_type.find(type => {
            return type.key == key
          }).label
        }
        return '-'
      }
    }
  },

  async created() {
    await this.loadStaffType()
    await this.loadStaffList()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = 'スタッフ一覧データです。'
  },

  methods: {
    delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.staff_obj.find(staff => {
          return staff.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', { data: data, target: 'staff' })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(() => {
            this.loadStaffList()
          })
      }
    },
    async loadStaffList() {
      const params = {}
      params['stat'] = [1]
      await axios
        .post(
          config.BASE_API_URL + '/staff/lists',
          this.setParams_S(params),
          this.cHeader
        )
        .then(async response => {
          console.log('loadStaffList response', response)
          this.staff_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.staff_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadStaffType() {
      // console.log('tag');
      return this.$store
        .dispatch('fetchBasicLists', { data: {}, target: 'staff_type' })
        .catch(err => Promise.reject(err))
        .then(() => {})
        .finally(() => {})
    },
    handleClick(target) {
      this.$router.push({ path: '/staff/' + target + '/' })
    }
  }
}
</script>
